import { StrictMode } from "react";

import "../styles.css";
import { ThemeProvider } from "../theme/theme-provider.tsx";
import { I18nProvider, LocalizationProvider } from "../locales";
import { AuthProvider } from "../lib/keycloak";
import { MatomoProvider } from "../lib/matomo";
import { RootErrorBoundary } from "../lib/error-boundary";
import * as TanStackQueryProvider from "../lib/tanstack-query/root-provider.tsx";

export function AppProviders({ children }: { children: React.ReactNode }) {
	return (
		<StrictMode>
			<RootErrorBoundary>
				<I18nProvider>
					<LocalizationProvider>
						{/* ThemeProvider sits outside AuthProvider so the loader
						    AuthProvider renders while Keycloak initialises is themed. */}
						<ThemeProvider>
							<AuthProvider>
								<MatomoProvider>
									<TanStackQueryProvider.Provider>
										{children}
									</TanStackQueryProvider.Provider>
								</MatomoProvider>
							</AuthProvider>
						</ThemeProvider>
					</LocalizationProvider>
				</I18nProvider>
			</RootErrorBoundary>
		</StrictMode>
	);
}
